export default __webpack_public_path__ + "static/media/sector 3.dd302460.jpg";